const $ = jQuery.noConflict();

'use strict';
const VideoSection = {

	init: function() {
		const $modal = $('.js-video-modal');
		if (!$modal.length) return;

		const $iframe = $modal.find('iframe');
		const $bgVideo = $('.video-section__bg');

		if ($bgVideo.length) {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							$bgVideo[0].play();
							observer.disconnect();
						}
					});
				},
				{threshold: 0.3}
			);
			observer.observe($bgVideo[0]);
		}

		$('.js-open-video').on('click', function() {
			$modal.addClass('is-active');
			$('body').css('overflow', 'hidden');

			if ($bgVideo.length) {
				$bgVideo[0].pause();
			}

			const src = $iframe.attr('src');
			if (src && !src.includes('autoplay=1')) {
				$iframe.attr('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
			}
		});

		$('.js-close-video').on('click', function() {
			$modal.removeClass('is-active');
			$('body').css('overflow', '');

			if ($bgVideo.length) {
				$bgVideo[0].play();
			}

			const src = $iframe.attr('src');
			if (src) {
				$iframe.attr('src', src.replace('&autoplay=1', '').replace('?autoplay=1', ''));
			}
		});
	}
};
export default VideoSection;
